import React from "react"

import i18next from '../i18n/config';
import {Link, Trans, useTranslation, useI18next} from 'gatsby-plugin-react-i18next';

// import ImgHeader from "../img/A_glowna_1/tlo_glowna.png";
import ImgFabricPL from "../img/P_nasze_zaklady_7/polska@0,75x.jpg";
import ImgFabricVN from "../img/P_nasze_zaklady_7/wietnam@0,75x.jpg";
import ImgFabricRU from "../img/P_nasze_zaklady_7/rosja@0,75x.jpg";
import ImgFabricCO from "../img/P_nasze_zaklady_7/kolumbia@0,75x.jpg";
// import ImgMap from "../img/P_nasze_zaklady_7/mapa_zklady@0,75x.jpg";
import IkoPassion from "../img/P_nasze_zaklady_7/iko_pasja.png";
import IkoFlex from "../img/P_nasze_zaklady_7/iko_elastycznosc.png";
import IkoGlob from "../img/P_nasze_zaklady_7/iko_globalizacja.png";
import IkoDevelop from "../img/P_nasze_zaklady_7/iko_rozwoj.png";
import IkoInv from "../img/P_nasze_zaklady_7/iko_innowacja.png";
import IkoQlt from "../img/P_nasze_zaklady_7/iko_jakosc.png";
import ImgDiag from "../img/mobile/historia_en.jpg";
import ImgDiagX from "../img/P_nasze_zaklady_7/historia_os.jpg";
import ImgAbUs from "../img/P_nasze_zaklady_7/o_nas.png";
import ImgOurPl from "../img/P_nasze_zaklady_7/nasze_zaklady.png";





export default function Header(props) {



    return (
            <React.Fragment>
                <section id="plants" class="plants firstSection">
                    <h1>{i18next.t('FabricH1')}</h1>
                    <p>{i18next.t('FabricDesc')}</p>
                    <div class="fabrics">
                        <div class="fabric">
                            <div> <img loading="lazy" src={ImgFabricPL} alt="Instanta Fabric PL" /></div>
                            <p onclick=" document.querySelector( '#VietnamTable' ).scrollIntoView( { behavior: 'smooth', block: 'start' } );">{i18next.t('FabricPL')}</p>
                        </div>
                        <div class="fabric">
                            <div><img loading="lazy" src={ImgFabricVN} alt="Instanta Fabric VN" /></div>
                            <p>{i18next.t('FabricVN')}</p>
                        </div>
                        <div class="fabric">
                            <div><img loading="lazy" src={ImgFabricCO} alt="Instanta Fabric CO" /></div>
                            <p>{i18next.t('FabricCO')}</p>
                        </div>
                    </div>
                    <aside class="AboutUsIcon">
                        <Link to={'/AboutUs/'}>
                        <img loading="lazy" src={ImgAbUs} alt="Instanta AboutUs Icon" />
                        <p>{i18next.t('AbousUsIcon')}</p>
                        </Link>
                    </aside>
                </section>


                {/*
                <section id="plantssection" class="plantssection"> 

                <h1>{i18next.t('FabricH1')}</h1>

<center>

    <table class="plantTable" id="VietnamTable"> 
        <tr>
            <td>
                <div class="fabric">
                    <div> <img loading="lazy" src={ImgFabricVN} alt="Instanta Fabric VN" /></div>
                </div>
            </td>
            <td>
                <table>
                    <tr><td><p>{i18next.t('OurPlants_ILD_Name')}</p></td></tr><tr>
                    <td><h2>{i18next.t('OurPlants_ILD_Title')}</h2></td></tr>
                    <tr><td class="justify"><h3>{i18next.t('OurPlants_ILD_Desc')}</h3></td></tr>
                </table>
                
            </td>
        </tr>
    </table>

    <table class="plantTable">
        <tr>
            <td>
                <div class="fabric">
                    <div> <img loading="lazy" src={ImgFabricPL} alt="Instanta Fabric PL" /></div>
                </div>
            </td>
            <td>
                <table>
                    <tr><td><p>{i18next.t('OurPlants_Zory_Name')}</p></td></tr><tr>
                    <td><h2>{i18next.t('OurPlants_Zory_Title')}</h2></td></tr>
                    <tr><td class="justify"><h3>{i18next.t('OurPlants_Zory_Desc')}</h3></td></tr>
                </table>
                
            </td>
        </tr>
    </table>

    <table class="plantTable">
        <tr>
            <td>
                <div class="fabric">
                    <div> <img loading="lazy" src={ImgFabricPL} alt="Instanta Fabric PL" /></div>
                </div>
            </td>
            <td>
                <table>
                    <tr><td><p>{i18next.t('OurPlants_Skibno_Name')}</p></td></tr>
                    <tr><td><h2>{i18next.t('OurPlants_Skibno_Title')}</h2></td></tr>
                    <tr><td class="justify"><h3>{i18next.t('OurPlants_Skibno_Desc')}</h3></td></tr>
                </table>
            </td>
        </tr>
    </table>

    <table class="plantTable">
        <tr>
            <td>
                <div class="fabric">
                    <div> <img loading="lazy" src={ImgFabricPL} alt="Instanta Fabric PL" /></div>
                </div>
            </td>
            <td>
                <table>
                    <tr><td><p>{i18next.t('OurPlants_Wolczyn_Name')}</p></td></tr>
                    <tr><td><h2>{i18next.t('OurPlants_Wolczyn_Title')}</h2></td></tr>
                    <tr><td class="justify"><h3>{i18next.t('OurPlants_Wolczyn_Desc')}</h3></td></tr>
                </table>
            </td>
        </tr>
    </table>

    <table class="plantTable">
        <tr>
            <td>
                <div class="fabric">
                    <div> <img loading="lazy" src={ImgFabricPL} alt="Instanta Fabric PL" /></div>
                </div>
            </td>
            <td>
                <table>
                    <tr><td><p>{i18next.t('OurPlants_Turcja_Name')}</p></td></tr>
                    <tr><td><h2>{i18next.t('OurPlants_Turcja_Title')}</h2></td></tr>
                    <tr><td class="justify"><h3>{i18next.t('OurPlants_Turcja_Desc')}</h3></td></tr>
                </table>
            </td>
        </tr>
    </table>

    <table class="plantTable">
        <tr>
            <td>
                <div class="fabric">
                    <div> <img loading="lazy" src={ImgFabricCO} alt="Instanta Fabric CO" /></div>
                </div>
            </td>
            <td>
                <table>
                    <tr><td><p>{i18next.t('OurPlants_Kolumbia_Name')}</p></td></tr>
                    <tr><td><h2>{i18next.t('OurPlants_Kolumbia_Title')}</h2></td></tr>
                    <tr><td class="justify"><h3>{i18next.t('OurPlants_Kolumbia_Desc')}</h3></td></tr>
                </table>
            </td>
        </tr>
    </table>

    <table class="plantTable">
        <tr>
            <td>
                <div class="fabric">
                    <div> <img loading="lazy" src={ImgFabricPL} alt="Instanta Fabric PL" /></div>
                </div>
            </td>
            <td>
                <table>
                    <tr><td><p>{i18next.t('OurPlants_Wietnam_Name')}</p></td></tr>
                    <tr><td><h2>{i18next.t('OurPlants_Wietnam_Title')}</h2></td></tr>
                    <tr><td class="justify"><h3>{i18next.t('OurPlants_Wietnam_Desc')}</h3></td></tr>
                </table>
            </td>
        </tr>
    </table>

</center>

                </section> */}

                {/* <section id="mapsection" class="map">

                </section> */}



            </React.Fragment>

            )


}
